// src/components/TrustedBy.jsx
import React from 'react';
import '../../styles/components/_trustedby.scss';
import logouai from '../../images/logo-uai1.png';
import LogoCorfo  from '../../images/LogoCorfo.png';
import LogoInovatorium from '../../images/Innovatorium_logo.png';
import LogoImagine from'../../images/imagineLogo.png';
import logoMCI from'../../images/logoMCI.png';
import dassaultSystems from'../../images/Dassault_Systèmes_logo.png';

const TrustedBy = () => {
  const logos = [
    { src: LogoCorfo, alt: 'Corfo' },
    { src: logouai, alt: 'Universidad Adolfo Ibañez' },
    {src: LogoInovatorium, alt: "Inovatorium"},
    {src: LogoImagine, alt: "Imagine"},
    {src: logoMCI, alt: "MCI"},
    {src: dassaultSystems, alt: "Dassault Systems"},
  ];
  return (
    <section className="trustedby-banner">
      <h2>Our partners</h2>
      <div className="logos">
        {logos.map((logo, index) => (
          <img key={index} src={logo.src} alt={logo.alt} />
        ))}
      </div>
    </section>
  );
};

export default TrustedBy;
